import { RuleAttributes, RulePositionChange } from '@loyalty/shared-common/rule-api-client';

export function requiresReferral(jsonLogic: Record<string, any> | undefined | null): boolean {
  if (!jsonLogic) {
    return false;
  }
  const logic = jsonLogic?.and ?? jsonLogic?.or;
  return logic?.some(
    (criteria: Record<string, any>) =>
      criteria['some']?.some((criteriaPart: any) => criteriaPart?.var === 'event') &&
      criteria['some']?.some((criteriaPart: any) => criteriaPart?.['!!']?.var === 'referralCode'),
  );
}

export function arrayMove<T>(arr: Array<T>, fromIndex: number, toIndex: number): T[] {
  const data = [...arr];
  const element = arr[fromIndex];
  data.splice(fromIndex, 1);
  data.splice(toIndex, 0, element);
  return data;
}

export function moveRule(
  rules: RuleAttributes[],
  fromIndex: number,
  toIndex: number,
): { newRules: RuleAttributes[]; changes: RulePositionChange[] } {
  const newRules: RuleAttributes[] = arrayMove(rules, fromIndex, toIndex);

  const [min, max] = [fromIndex, toIndex].sort();
  const changes: RulePositionChange[] = newRules.slice(min, max + 1).map((rule, index) => {
    const newPosition = min + index;
    rule.position = newPosition;
    return {
      ruleId: rule.id,
      newPosition,
      positionVersion: rule.positionVersion,
    };
  });

  return { newRules, changes };
}
